import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";
export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "maps",
        object: "map",
        header: [
            { text: "Titulo", value: "title" },
            { text: "Acciones", value: "actions", sortable: false }
        ]
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions,
    },
    getters: {
        ...genericStore.getters
    }
};
